{
  "fr-FR": {
    "button": "Besoin d'aide ?",
    "close": "Fermer"
  },
  "en-US": {
    "button": "Need help ?",
    "close": "Close"
  },
  "es-ES": {
    "button": "Need help ?",
    "close": "Close"
  },
  "de-DE": {
    "button": "Need help ?",
    "close": "Close"
  }
}
